<template>
  <div
    class="v-product"
    :class="{
      mounted: mounted,
    }"
  >
    <!-- 面包屑 -->
    <v-breadcrumb
      class="container"
      :class="{
        'container--narrower': narrowerscreen,
      }"
      :show-from-path="true"
      :title="product_res.post_title"
      route="product-index"
      :extend-data="product.categories"
    />
    <div class="product-template-section">
      <div
        class="container"
        :class="[narrowerscreen ? 'narrowerscreen' : '', productConfig.gallery_postion]"
      >
        <div class="product-left">
          <div v-if="product_res.gallery && product_res.gallery.length">
            <!-- 媒体库 -->
            <!-- 移动端默认显示 -->
            <product-swiper
              class="v-product__swiper"
              v-if="productConfig.gallery_show_config == 'default' || !isPcStyle"
              :gallery="product_res.gallery"
              :pagination-style="swiperPaginationStype"
              :enable-pic-zoom="isPcStyle && productConfig.pic_zoom"
              :product-res="product_res"
              is-product="is_product"
              v-model="swiperIndex"
              :product-info="product_info"
              :autoplay="productConfig.swiper_autoplay"
            />
            <!-- 平铺 -->
            <v-media-flat
              :gallery="product_res.gallery"
              v-else-if="productConfig.gallery_show_config == 'flat' && isPcStyle"
              :product_res="product_res"
              :pic_zoom="productConfig.pic_zoom"
              is_product="is_product"
              theme="vogue"
              :productInfo="product_info"
              :tag-show-first="true"
            ></v-media-flat>
          </div>
          <div v-else style="position: relative">
            <v-product-tag
              v-if="$store.state.product_tag_list[product_res.ID]"
              :productTag="$store.state.product_tag_list[product_res.ID]"
              :productInfo="product_info"
            ></v-product-tag>
            <img :src="defaultImage" alt />
          </div>

          <!-- 开启tab -->
          <!-- tab居左 -->
          <div
            class="productDescriptionWrap accordion m_hidden title_font"
            id="vogue-pro-accordion3"
            v-if="
              isTabs &&
              productConfig.gallery_show_config == 'default' &&
              show_tab == 'left' &&
              pc_style
            "
          >
            <template>
              <div
                v-for="(item, index) in describe_tabs"
                :key="item.title + index"
                @click="scrollTab"
              >
                <v-collapse-card
                  parent="#vogue-pro-accordion3"
                  :title="item.title"
                  :default_show="item.type == 'describe' && !item.show"
                  :collapse_key="'productContainer' + item.type + index"
                  icon="plus-minus"
                  theme="vogue"
                >
                  <div style="overflow: hidden; position: relative">
                    <div
                      class="product-description tinymce-content default_css page_text_font"
                      v-html="re_remover_class(item.content)"
                    ></div>
                  </div>
                </v-collapse-card>
              </div>
            </template>
          </div>
        </div>
        <div class="product-right">
          <div class="product-right-content">
            <!-- 添加商品 -->
            <v-product-add
              ref="productadd"
              theme="vogue"
              :product="product_res"
              :count_down="count_down"
              :count_down_show="count_down_show"
              :cart_type="cart_type"
              :stock="now_variant.buy_able && stock"
              :show_currency_selector="show_currency_selector"
              :paypal_product_position="paypal_product_position"
              :variants_show_config="variants_show_config"
              :bulk_coupon="bulk_coupon"
              :has_bulk_coupon="has_bulk_coupon"
              :variant_attrs="variant"
              :add_cart_data="add_cart_data"
              :now_variant="now_variant"
              :enable_facebook="enable_facebook"
              :enable_twitter="enable_twitter"
              :enabel_pinterest="enabel_pinterest"
              :code_display="code_display"
              :code_display_show="code_display_show"
              :currency_style="currency_style"
              :paypal_enabled="paypal_enabled"
              :buyxgety_coupon="buyxgety_coupon"
              :buyxgety-setting="buyxgetySetting"
              :incentives_data="incentives_data"
              :custom_button="custom_button"
              :palette_attrs="palette_attrs"
              :palette_config="palette_config"
              :visitors="visitors"
              :hide_add_btn="hide_add_btn"
              :show_comment_score="show_comment_score"
              :comment="comment"
              :show_product_price="show_product_price"
              :hide_number_select="hide_number_select"
              :show_style="show_style"
              :enable_size_chart="enable_size_chart"
              :combinations="combinations"
              :style_combination="style_combination"
              :combination_active="combination_active"
              :add_group_products="add_group_products"
              :group_product="group_product"
              :getSymbolFromCurrency="getSymbolFromCurrency"
            ></v-product-add>
            <!-- 组合商品 -->
            <v-groupedproduct
              v-if="
                add_group_products &&
                (group_products_position == 'button below' ||
                  group_products_position == 'above') &&
                group_product &&
                group_product.length > 0
              "
              :price="now_variant.price"
              :regular_price="now_variant.regular_price"
              :stock="now_variant.buy_able && stock"
              :loading="$store.state.disabled"
              :group_product="group_product"
              :group_product_price_rules="group_product_price_rules"
              :group_product_all="group_product_all"
              :group_products_title="group_products_title"
              :group_products_position="group_products_position"
              :product="product"
              :getSymbolFromCurrency="getSymbolFromCurrency"
              :smallimg="smallimg"
              :variant_attrs="variant_attrs"
              :variant="variant"
              :cart_type="cart_type"
              theme="vogue"
              :show_currency_selector="show_currency_selector"
              :currency_style="currency_style"
              :narrowerscreen="narrowerscreen"
              :group_product_style="group_product_style"
            ></v-groupedproduct>
            <div class="payment_img" v-if="payment_img">
              <img :src="payment_img" alt />
            </div>

            <!-- 未开启tab -->
            <template v-if="!isTabs">
              <div style="overflow: hidden; position: relative">
                <div
                  class="product-description tinymce-content default_css"
                  ref="content"
                  v-html="re_remover_class(product_res.post_content)"
                ></div>
              </div>
            </template>

            <!-- 开启tab -->
            <!-- 媒体库平铺， showTab 居右, 移动端 -->
            <!-- 移动端时，非全宽 -->
            <template v-else>
              <div
                class="productDescriptionWrap accordion"
                :style="{
                  marginTop:
                    productConfig.gallery_show_config == 'flat' ||
                    (show_tab == 'right' && '20px'),
                }"
                id="vogue-pro-accordion"
                v-if="
                  productConfig.gallery_show_config == 'flat' ||
                  show_tab === 'right' ||
                  (!pc_style && show_tab !== 'full_width')
                "
              >
                <template>
                  <div
                    v-for="(item, index) in describe_tabs"
                    :key="item.title + index"
                    @click="scrollTab"
                  >
                    <v-collapse-card
                      parent="#vogue-pro-accordion"
                      :title="item.title"
                      :default_show="item.type == 'describe' && !item.show"
                      :collapse_key="'productContainer' + item.type + index"
                      icon="plus-minus"
                      theme="vogue"
                    >
                      <div style="overflow: hidden; position: relative">
                        <div
                          class="product-description tinymce-content default_css page_text_font"
                          v-html="re_remover_class(item.content)"
                        ></div>
                      </div>
                    </v-collapse-card>
                  </div>
                </template>
              </div>
            </template>

            <v-groupedproduct
              v-if="
                add_group_products &&
                group_products_position == 'right' &&
                show_tab != 'left' &&
                show_tab != 'full_width' &&
                group_product &&
                group_product.length > 0
              "
              :price="now_variant.price"
              :regular_price="now_variant.regular_price"
              :stock="now_variant.buy_able && stock"
              :loading="$store.state.disabled"
              :group_product="group_product"
              :group_product_price_rules="group_product_price_rules"
              :group_product_all="group_product_all"
              :group_products_title="group_products_title"
              :group_products_position="group_products_position"
              :product="product"
              :getSymbolFromCurrency="getSymbolFromCurrency"
              :smallimg="smallimg"
              :variant_attrs="variant_attrs"
              :variant="variant"
              :cart_type="cart_type"
              theme="vogue"
              :show_currency_selector="show_currency_selector"
              :currency_style="currency_style"
              :narrowerscreen="narrowerscreen"
              :group_product_style="group_product_style"
            ></v-groupedproduct>
          </div>
        </div>
      </div>
      <v-amplification
        v-if="productConfig.pic_zoom"
        :gallery="product_res.gallery"
        :activeIndex="swiperIndex"
        :screenWidth="screenWidth"
      ></v-amplification>
    </div>
    <div
      class="container pc-margin"
      :class="narrowerscreen ? 'narrowerscreen_tabs' : ''"
      v-if="
        isTabs &&
        productConfig.gallery_show_config == 'default' &&
        show_tab == 'full_width'
      "
    >
      <v-descrip-tabs :tab_data="describe_tabs"></v-descrip-tabs>
    </div>
    <div class="container">
      <v-groupedproduct
        v-if="
          add_group_products &&
          group_products_position == 'below' &&
          group_product &&
          group_product.length > 0
        "
        :price="now_variant.price"
        :regular_price="now_variant.regular_price"
        :stock="now_variant.buy_able && stock"
        :loading="$store.state.disabled"
        :group_product="group_product"
        :group_product_price_rules="group_product_price_rules"
        :group_product_all="group_product_all"
        :group_products_title="group_products_title"
        :group_products_position="group_products_position"
        :product="product"
        :getSymbolFromCurrency="getSymbolFromCurrency"
        :smallimg="smallimg"
        :variant_attrs="variant_attrs"
        :variant="variant"
        :cart_type="cart_type"
        theme="vogue"
        :show_currency_selector="show_currency_selector"
        :currency_style="currency_style"
        :narrowerscreen="true"
        :group_product_style="group_product_style"
      ></v-groupedproduct>
    </div>

    <v-guess-like
      :comment="comment"
      v-if="recommended_product && show_recommended"
      :recommended_product="recommended_product"
      :cart_type="cart_type"
      :product_id="product.ID"
      :show_currency_selector="show_currency_selector"
      :currency_style="currency_style"
      :palette_config="palette_config"
      :card_type="card_type"
      theme="vogue"
    ></v-guess-like>
    <v-comments
      v-if="comment"
      :comment="comment"
      :review_count="product.review_count"
      :average_rating="product.average_rating"
      :rating_count="product.rating_count"
      :product_id="product.ID"
    ></v-comments>
    <v-new-quick-add-cart
      :quick-add-cart="quickAddCart"
      v-if="quick_add_cart"
      :show-quick-add-cart="quick_add_cart"
      :variant-new="now_variant"
      :product="product"
      :stock="now_variant.buy_able && stock"
      :price="now_variant.price"
      :regular-price="now_variant.regular_price"
      :loading="$store.state.disabled"
      :variant-attrs="product_res.variant_attrs"
      :current-variant="variant"
      :addproduct="add_cart_data"
      @fatherMethod="add_cart"
      :show-currency_selector="show_currency_selector"
      :currency-style="currency_style"
    ></v-new-quick-add-cart>
    <div class="container">
      <v-groupedproduct
        v-if="
          add_group_products &&
          (group_products_position == 'foot' ||
            (group_products_position == 'right' &&
              (show_tab == 'left' || show_tab == 'full_width'))) &&
          group_product &&
          group_product.length > 0
        "
        :price="now_variant.price"
        :regular_price="now_variant.regular_price"
        :stock="now_variant.buy_able && stock"
        :loading="$store.state.disabled"
        :group_product="group_product"
        :group_product_price_rules="group_product_price_rules"
        :group_product_all="group_product_all"
        :group_products_title="group_products_title"
        group_products_position="foot"
        :product="product"
        :getSymbolFromCurrency="getSymbolFromCurrency"
        :smallimg="smallimg"
        :variant_attrs="variant_attrs"
        :variant="variant"
        :cart_type="cart_type"
        theme="vogue"
        :show_currency_selector="show_currency_selector"
        :currency_style="currency_style"
        :narrowerscreen="true"
        :group_product_style="group_product_style"
      ></v-groupedproduct>
    </div>
   
    <slot name="modules-list"></slot>
  </div>
</template>

<script>
import vProductAdd from "../../../../venue/js/view/product/productAdd";
import vCollapseCard from "@/js/components/common/collapseCard";
import vComments from "@/js/components/view/comments/comments";
import vNewQuickAddCart from "@/js/components/view/quickaddcart/newQuickAddCart.vue";
import vGroupedproduct from "@/js/components/view/groupedproduct/index";
import vProductSwiper from "../../../../venue/js/view/product/productSwiper";
import vMediaFlat from "./MediaFlat";
import getSymbolFromCurrency from "currency-symbol-map";
import { mapActions, mapState } from "vuex";
import vAmplification from "@/js/components/common/amplification.vue";
import vDescripTabs from "./descriptabs.vue";
import vGuessLike from "@/js/components/view/guesslike/guesslike";
import vProductTag from "@/js/components/view/productTag/productTag";
import mixGroupProduct from "@/js/mixins/mixGroupProduct";
import googleAnalysis from "@/js/lib/ga";
import mixProductTag from "@/js/mixins/mixProductTag";
import ProductSwiper from "@/js/components/ProductSwiper/index.vue";

export default {
  props: [
    "variants_show_config",
    "group_product_all",
    "quick_add_cart",
    "product",
    "count_down",
    "recommended_product",
    "comment",
    "add_group_products",
    "group_products_title",
    "group_products_position",
    "variant_attrs",
    "cart_type",
    "show_currency_selector",
    "paypal_product_position",
    "enable_facebook",
    "enable_twitter",
    "enabel_pinterest",
    "code_display",
    "currency_style",
    "mb_gallery",
    "paypal_enabled",
    "sharing_incentives",
    "product_tabs",
    "payment_img",
    "is_custom_button",
    "palette_config",
    "visitors_counter",
    "show_comment_score",
    "show_product_price",
    "hide_number_select",
    "show_style",
    "product_tag",
    "card_type",
    "show_tab",
    "enable_size_chart",
    "style_combination_enable",
    "style_combination",
    "group_product_style",
    "quickAddCart",
  ],
  data() {
    return {
      product_res: {},
      count_down_show: false,
      variant: [],
      smallimg: [],
      show_recommended: "",
      add_cart_data: {
        product_id: null,
        quantity: 1,
      },
      now_variant: {},
      getSymbolFromCurrency,
      stock: true,
      bulk_coupon: {},
      has_bulk_coupon: false,
      buyxgety_coupon: [],
      incentives_data: [],
      code_display_show: [],
      tabs_page: {},
      custom_button: null,
      palette_attrs: [],
      visitors: null,
      hide_add_btn: false,
      swiper_index: {
        activeIndex: 0,
      },
      describe_tabs: [],
      isTabs: false,
      combinations: {}, //用于存放款式组合数据
      combination_active: 0, //款式组合当前商品索引
      search_add_id_on: false, //控制第一次进来时不在url上拼接变种id
      sticky_top: 0, //粘性定位top值
      current_scrollTop: 0, //当前滚动高度

      price: 0, //产品卡片标签的价格
      regularPrice: 0, //产品卡片标签的原价格
      buyxgetySetting: {}, //满送优惠设置
      mounted: false,
      swiperIndex: 0, // swiper index
    };
  },
  mixins: [mixGroupProduct, mixProductTag],
  methods: {
    add_cart(data,onlySelf) {
      this.$refs.productadd.add_cart(data,onlySelf);
    },
    fixed_right_add() {
      let window_scroll = this.$(window).scrollTop();
      let header = this.$(".section-header"); // 整个头部
      let notice = this.$(".section-header-notice"); // 公告栏
      let nav = this.$(".site-header"); // 导航栏
      let quick = this.$("div.quickPurchased"); // 快捷加购
      let notice_height = notice.height() || 0; // 公告栏高度
      let nav_height = nav.height() || 0; // 导航栏高度
      let fixed_top = 0; // 用于处理头部导航固定的总高度
      let window_height = this.screenHeight; //浏览器高度
      let right_child_height = this.$(".product-right-content").outerHeight(); // 右侧内容高度;
      let quick_height = (quick.css("display") != "none" && quick.outerHeight()) || 0; // 快捷加购高度
      // 头部导航固定时处理
      if (header.css("position") == "fixed") {
        fixed_top = notice_height + nav_height;
      } else if (notice.css("position") == "fixed") {
        fixed_top = notice_height;
      } else if (nav.css("position") == "fixed") {
        fixed_top = nav_height;
      }

      // 计算固定内容超过浏览器的高度
      let overClientHeight =
        right_child_height - window_height > 0 ? right_child_height - window_height : 0;

      // 当固定的内容不超过浏览器高度
      if (!overClientHeight) {
        this.$(".product-right-content").css({
          position: "sticky",
          top: fixed_top,
          zIndex: 99,
        });
      }
      // 当固定的内容超过浏览器
      else if (overClientHeight) {
        this.sticky_top = this.sticky_top - window_scroll + this.current_scrollTop;
        this.current_scrollTop = window_scroll;
        if (this.sticky_top < -overClientHeight - quick_height) {
          this.sticky_top = -overClientHeight - quick_height;
        }
        if (this.sticky_top > fixed_top) {
          this.sticky_top = fixed_top;
        }
        this.$(".product-right-content").css({
          position: "sticky",
          top: this.sticky_top,
          zIndex: 99,
        });
      }
    },
    /**
     * 屏幕发生变化处理
     * todo 需要优化
     *  */
    Resize() {
      if (
        this.screenWidth > 980 &&
        this.show_tab == "left" &&
        this.productConfig.gallery_show_config == "default"
      ) {
        window.addEventListener("scroll", this.fixed_right_add, true);
      } else {
        window.removeEventListener("scroll", this.fixed_right_add);
        this.$(".product-right-content").css({ position: "static" });
      }
    },
    scrollTab(e) {
      let prev_scroll_value = e.target.getBoundingClientRect().top;
      setTimeout(
        (p) => {
          let next_scroll_value = e.target.getBoundingClientRect().top;
          if (p - 500 > next_scroll_value) {
            this.$("html,body").animate(
              { scrollTop: document.documentElement.scrollTop + next_scroll_value - 100 },
              500
            );
          }
        },
        500,
        prev_scroll_value
      );
    },
    /**
     * 修改副文本
     * 1、iframe 套上div
     *  */
    fiexContent() {
      const dom = this.$refs.content;

      const iframes = this.$(dom).find("iframe");

      if (iframes.length > 0) {
        iframes.each((index) => {
          this.$(iframes[index])?.wrapAll('<div class="detail-iframe-wrapper"></div>');
        });
      }
    },
    ...mapActions({
      get_product_tag: "change_product_tag_list", // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
    }),
  },
  beforeMount() {
    if (this.recommended_product) {
      this.show_recommended = !this.recommended_product.shieldProduct.includes(
        this.product.ID
      );
    }

    this.product_res = this.product;
    this.now_variant = this.product;

    this.$store.dispatch("change_now_variant", this.now_variant);
    if (this.count_down) {
      this.count_down_show =
        this.count_down.detail.type == "all" ||
        this.count_down.detail.product_ids.includes(this.product.ID) ||
        this.count_down.detail.category_ids.some((item) => {
          return this.product.categories.some((subitem) => {
            return subitem.id == item;
          });
        });
    }
    if (this.product.variant_attrs && this.product.variant_attrs.length) {
      this.product.variant_attrs.forEach((item) => {
        this.variant.push({
          name: item.name,
          value: item.value[0],
        });
      });
    }
    this.variant_id = this.getSearch("variant=");
    if (this.variant_id && this.product.variants && this.product.variants.length) {
      this.product.variants.some((item) => {
        if (item.ID == this.variant_id) {
          this.variant.forEach((variant_item) => {
            item.attrs.some((attrs_item) => {
              if (variant_item.name == attrs_item.name) {
                variant_item.value = attrs_item.value;
                return true;
              }
            });
          });
        }
      });
    }
    this.$axios.get(API.get_coupons + this.product.ID).then((res) => {
      let { bulk_coupon, buyxgety_coupon, setting } = res.data;
      if (bulk_coupon) {
        this.bulk_coupon = bulk_coupon;
        this.has_bulk_coupon = true;
      }
      if (buyxgety_coupon) {
        this.buyxgety_coupon = buyxgety_coupon;
      }
      if (setting) {
        this.buyxgetySetting = setting;
      }
    });
    if (this.code_display) {
      this.$axios.get(API.get_code_display + this.product.ID).then((res) => {
        this.code_display_show = res.data;
      });
    }
    if (this.sharing_incentives) {
      this.$axios.get(API.incentives + this.product.ID).then((res) => {
        const { data } = res.data;
        this.incentives_data = data;
      });
    }
    if (this.is_custom_button) {
      this.hide_add_btn = true;
      this.$axios
        .get(API.custom_button, {
          params: { product_ids: this.product.ID },
        })
        .then((res) => {
          this.custom_button = res.data[0].custom_button;
          let { is_cart_detail_page } = this.custom_button;
          this.hide_add_btn = !!is_cart_detail_page;
        });
    }
    if (this.palette_config) {
      let params = {
        "filter[product_id]": this.product.ID,
      };
      this.$axios.get(API.palette, { params }).then((res) => {
        if (res && res.data && res.data[this.product.ID])
          this.palette_attrs = res.data[this.product.ID];
      });
    }
    if (this.visitors_counter) {
      this.$axios.get(API.visitors_counter + this.product.ID).then((res) => {
        this.visitors = res.data;
      });
    }
    if (this.style_combination_enable) {
      this.$axios
        .get(`${API.style_combination}?filter[product_ids]=${this.product.ID}`)
        .then((res) => {
          if (res?.data?.data?.length > 0) {
            this.combinations = res.data.data[0].style_combination;

            this.combinations.items?.forEach((item, index) => {
              if (item.product_id == this.product.ID) {
                this.combination_active = index;
              }
            });
          }
        });
    }
  },
  async mounted() {
    // 挂载
    this.mounted = true;
    const skeletonDom = document.getElementsByClassName("product-skeleton");
    // 直接删除元素
    skeletonDom?.[0]?.remove();

    // 调用window.onresize监听浏览器窗口变化
    this.Resize();
    window.onresize = () => {
      this.Resize();
    };

    let arr = [];
    let getAll = [];
    this.isTabs = this.product_tabs && this.product_tabs.length > 0;
    console.log("this.product_tabs", this.product_tabs, this.show_tab);

    if (this.product_tabs?.length > 0) {
      let describeFlag = -1
      this.product_tabs.forEach((item, index) => {
        let obj = {};
        if (item.type == "describe") {
          obj = {
            title: item.title,
            content: this.product_res.post_content,
            type: "describe",
            show: item.show,
          };
          if(describeFlag !== -1 ){
            if(obj?.title){
              arr.splice(describeFlag, 1)
              arr.push(obj)
              describeFlag = arr.length - 1
            }
          }else {
            arr.push(obj);
            describeFlag = arr.length - 1
          }
        } else if (item.type == "others") {
          obj = {
            title: item.title,
            content: item.content || "",
            type: item.type,
          };
          arr.push(obj);
        } else if (item.type == "page" && item.page_id) {
          let p = new Promise((resolve, reject) => {
            this.$axios.get(`/api/store/pages/${item.page_id}`).then((res) => {
              if (res.data) {
                res.data.position = index;
              }
              resolve(res.data);
            });
          });
          getAll.push(p);
        }
      });
      if (getAll.length) {
        await Promise.all([...getAll]).then((res) => {
          res.forEach((item) => {
            let obj = {
              title: item.title,
              content: item.content,
              type: "page",
            };
            arr.splice(item.position, 0, obj);
          });
        });
      }
    } else {
      let obj = {
        title: "Description",
        type: "describe",
        content: this.product_res.post_content,
      };
      arr.push(obj);
    }
    this.describe_tabs = arr;

    if (this.product_tag) {
      this.get_product_tag(this.product_res.ID);
    }

    // 发生fb事件
    this.send_fb_event("ViewContent", {
      content_type: "product_group",
      content_ids: [this.product.ID],
      value:
        this.product["variants"] && this.product["variants"].length
          ? this.product["variants"][0]["price"]
          : this.product["price"],
      content_name:
        this.product["variants"] && this.product["variants"].length
          ? this.product["variants"][0]["title"]
          : this.product["title"],
      currency: window.checkoutcurrency,
      content_category:
        this.product["categories"] && this.product["categories"].length
          ? this.product["categories"][0]["name"]
          : "",
    });

    // 富文本处理
    this.fiexContent();
    // 谷歌分析事件，浏览页面
    googleAnalysis.event("detail", {
      items: [
        {
          id: this.product?.ID,
          name: this.product?.post_title,
          brand: "",
          category: this.product?.categories?.[0]?.name,
          price: this.product?.price,
          variant: this.variant?.[0]?.value,
        },
      ],
    });
  },
  created() {
    this.bus.$on("get_variant", (res) => {
      this.variant[res.index].value = res.val;
    });
  },
  computed: {
    ...mapState({
      productConfig: ({ options }) => options?.theme?.pages?.product?.config || {},
      // 屏幕宽度
      screenWidth: (state) => state.screenWidth,
      // 屏幕高度
      screenHeight: (state) => state.screenHeight,
      // 是否移动端
      isMobile: ({ isMobile }) => isMobile,
    }),
    /**
     * swiper 分页样式
     * 屏幕看度 < 768 用dot
     * venue 用list
     * 媒体库在下用inline
     * 居左用 left
     */
    swiperPaginationStype() {
      if (this.screenWidth < 768) {
        return "dot";
      }

      if (this.productConfig.gallery_postion === "gallery_bottom") {
        return "inline";
      }

      if (this.productConfig.gallery_postion === "gallery_left") {
        return "left";
      }

      return "inline";
    },
    /**
     * 是否是pc样式
     * >= 768 是pc
     * < 768 是移动端
     *  */
    isPcStyle() {
      return !this.isMobile;
    },
    // 窄屏显示
    narrowerscreen() {
      return this.productConfig?.other?.narrowerscreen || false;
    },
  },
  watch: {
    variant: {
      handler(newName, oldName) {
        const { variants, gallery } = this.product

        variants?.some((item) => {
          let res = item.attrs.every((subitem) => {
            return newName.some((lowitem) => {
              return lowitem.name == subitem.name && lowitem.value == subitem.value;
            });
          });
          if (res) {
            //在改变变种商品时获取该变种的属性赋值给产品卡片标签
            this.price = item.price;
            this.regularPrice = item.regular_price;

            // 如果变种商品有图片则切换轮播图
            this.now_variant = item;
            this.$store.dispatch("change_now_variant", item);
            const featureImageId = item?.feature_image?.ID || null;

            if (featureImageId) {
              this.$store.dispatch("change_feature_image_id", item.feature_image.ID);
            } else {
              this.$store.dispatch("change_feature_image_id", 0);
            }

            // 根据图片id，判断当前选中是哪种图片
            gallery?.some((galleryItem, index) => {
              if (galleryItem.ID == this.$store.state.feature_image_id) {
                this.swiperIndex = index
              }
            })

            if (this.search_add_id_on) {
              window.history.replaceState(
                {},
                "",
                this.replaceSearch("variant", item.ID, true)
              );
            } else {
              this.search_add_id_on = true;
            }
            this.add_cart_data.variant_id = item.ID;
            this.stock = true;
            return res;
          } else {
            this.$store.dispatch("change_feature_image_id", 0);
            this.stock = false;
          }
        });
      },
      immediate: false,
      deep: true,
    },
  },
  components: {
    vProductAdd,
    vComments,
    vNewQuickAddCart,
    vGroupedproduct,
    vProductSwiper,
    vMediaFlat,
    vCollapseCard,
    vAmplification,
    vDescripTabs,
    vGuessLike,
    vProductTag,
    ProductSwiper,
  },
};
</script>

<style lang="scss">
.v-product {
  .product_single {
    &_add_button {
      height: 48px;
      line-height: 48px;
      padding-top: 0;
      padding-bottom: 0;
      margin-bottom: 16px !important;
    }
  }
  .paypal-button-render {
    margin-bottom: 16px !important;
  }
}
</style>

<style scoped lang="scss">
.v-product {
  padding-top: 40px;
  position: relative;
  opacity: 0;
  transition: all 0.4s;
  &.mounted {
    opacity: 1;
  }
  &__swiper {
    ::v-deep {
      .media-swiper {
        .media-swiper__slide-card {
          img {
            &:not(.lazyloaded) {
              min-height: 400px ;
              width: 100%;
              object-fit: cover;
              background-color: #f2f2f2;
            }
          }
        }

        &__thumb {
          img {
            background-color: #f2f2f2;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    padding-top: 0px;
    .v-breadcrumb {
      margin-top: 16px;
    }
    &::v-deep {
      .product-swiper {
        &__dot-pagination {
          margin-top: 0;
        }
      }
    }
  }
}
.product-template-section {
  padding-bottom: 80px;
  position: relative;
  .container {
    display: flex;
    .product-left {
      position: relative;
      width: 50%;
    }
    .product-right {
      width: 50%;
      padding-left: 30px;
      &::v-deep .product_single_content_box {
        .product_single_price_text {
          margin-top: 9px;
        }
        .product_single_add .product_single_add_button {
          .selectpricewrap .money {
            & > span:nth-child(1) {
              margin-right: -6px;
            }
          }
        }
        .product_single_price {
          .money {
            // font-family: "Muli-ExtraBold" !important;
            & > span:nth-child(1) {
              margin-right: -6px;
            }
          }
        }
      }
      &::v-deep .product_single_share {
        margin-top: 12px;
      }
    }
    &::v-deep .collapseCard {
      .collapseCardTitle {
        padding-top: 37.5px;
        padding-bottom: 37.5px;
        margin-bottom: 0;
        h5 {
          font-size: 14px;
          // font-family: "Muli-Bold";
          color: #454545;
        }
      }
    }
    .productDescriptionWrap {
      margin-top: 80px;
      margin-bottom: 40px;
      border-top: 1px solid #e3e3e3;
      .product-description {
        overflow-x: auto;
        font-size: 16px;
        line-height: 1.65;
        padding-bottom: 32px;
        // p {
        //   margin-bottom: 0;
        // }
        ul {
          li {
            list-style: inside;
          }
        }
        img,
        iframe,
        video {
          max-width: 100% !important;
        }
        pre {
          white-space: pre-wrap;
        }
      }
    }
  }
}
.pc-margin {
  margin: 60px auto;
}

@media screen and (min-width: 1200px) {
  .product-template-section {
    .gallery_bottom,
    .gallery_left {
      padding-left: 30px;
      padding-right: 30px;
      .product-left {
        width: 694px;
        width: 48.8732%;
        padding-right: 20px !important;
        &::v-deep {
          .vogue-media {
            .rightImg {
              width: calc(100% - 120px);
              max-width: 554px;
              margin: 0 0 0 20px;
              .swiper,
              .swiper-slide {
                background-color: rgba(0, 0, 0, 0) !important;
              }
            }
          }
          .slideItem {
            .imgCard {
              img {
                background-color: rgba(248, 248, 248, 0) !important;
              }
            }
          }
        }
      }
      .product-right {
        width: 51.1268%;
        padding-left: 48px;
      }
    }
    .narrowerscreen.gallery_bottom,
    .narrowerscreen.gallery_left {
      .product-left {
        &::v-deep {
          .vogue-media {
            .rightImg {
              width: calc(100% - 120px);
              max-width: 500px;
              margin: 0 0 0 20px;
              .swiper,
              .swiper-slide {
                background-color: rgba(0, 0, 0, 0) !important;
              }
            }
          }
        }
      }
    }
    .narrowerscreen.gallery_bottom {
      max-width: 1200px;
      .product-left {
        width: 652px;
        width: 59.2727%;
        padding-right: 20px !important;
      }
      .product-right {
        width: 40.7273%;
        padding-left: 48px;
      }
    }
    .narrowerscreen.gallery_left {
      max-width: 1200px;
      padding-left: 56px;
      padding-right: 56px;
      .product-left {
        width: 640px;
        width: 58.8235%;
        padding-right: 20px !important;
      }
      .product-right {
        width: 41.1765%;
        padding-left: 48px;
      }
    }
  }
  .narrowerscreen_tabs {
    max-width: 1200px;
  }
}
@media screen and (max-width: 768px) {
  .product-template-section {
    padding-bottom: unset;
    .title {
      width: 250px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
    }
    :not(header).container {
      flex-wrap: wrap;
      padding-left: 24px !important;
      padding-right: 24px !important;
      padding-top: 0px;
      .product-left {
        width: 100%;
        margin-left: -24px;
        margin-right: -24px;
        flex-grow: 1;
        // .product-col-left {
        //   max-width: 100%;
        // }
      }
      .product-right {
        width: 100%;
        padding-left: 0;
        &::v-deep .product_single_content_box {
          .product_single_price_text {
            margin-top: -5px;
          }
        }
        &::v-deep .collapseCard {
          .collapseCardTitle {
            padding-top: 23.5px;
            padding-bottom: 23.5px;
          }
        }
        div {
          .select-sort-by {
            width: 100%;
          }
        }
      }
      .productDescriptionWrap {
        margin-top: 20px;
      }
      &::v-deep .PageOverlay {
        z-index: 999;
      }
    }
  }
  .m_hidden {
    display: none;
  }
  .pc-margin {
    margin-top: 0;
  }
}
@media screen and (max-width: 480px) {
  .product-template-section {
    padding-bottom: 40px;
  }
}
.product-template-section{
  .narrowerscreen {
    .product-right {
      &::v-deep .product_add_cart{
        .grouped_products_default{
          .product-groups-select {
            width: 185px !important;
          }
        }
      }
      .product-right-content {
        &::v-deep .grouped_products_default{
          .product-groups-select {
            width: 185px !important;
          }
        }
      }
    }
  }
}
</style>
